import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    DatePicker,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,
    PatchButton, PostButton,
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import SerialOrderlistForm from "./serial_receive_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import SerialOrderlistEdit from './serial_orderlist_edit'
import dayjs from 'dayjs';
import BudgetAndQuantityControl from './budget_and_quantity_control'
import axios from 'axios'

const SerialOrderlistTable = ({
    rowKey = "subscription_orderlist_id",
    keyPrefix = "cataloging.serial_orderlist_management",
    showAllColumns = true,
    propsShowColumns,
    propsSubscriptionid,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
        subscriptionid: propsSubscriptionid || null,
        start_planneddate: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end_planneddate: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    const columns = [
        {
            title: t("order_number"),
            key: "subscription_orderlist_serial",
            dataIndex: "subscription_orderlist_task_data",
            sorter: false,
            render: (text, record, index) => {
                let subscription_orderlist_task_data = text || []
                let subscription_orderlist_task_first = subscription_orderlist_task_data?.find((ele) => true)
                return <Row justify="center">
                    <Col>
                        <Typography.P>
                            {subscription_orderlist_task_first?.subscription_orderlist_serial}

                        </Typography.P>
                    </Col>
                </Row>
            }
        },
        {
            title: t("name"),
            key: "task_name",
            dataIndex: "subscription_orderlist_task_data",
            sorter: false,

            render: (text, record, index) => {
                let subscription_orderlist_task_data = text || []
                let subscription_orderlist_task_first = subscription_orderlist_task_data?.find((ele) => true)
                return <Row justify="center">
                    <Col>
                        <Typography.P>
                            {subscription_orderlist_task_first?.task_name}

                        </Typography.P>
                    </Col>
                </Row>
            }
        },
        {
            title: t("creator"),
            key: "create_user_name",
            dataIndex: "subscription_orderlist_task_data",
            sorter: false,
            render: (text, record, index) => {
                let subscription_orderlist_task_data = text || []
                let subscription_orderlist_task_first = subscription_orderlist_task_data?.find((ele) => true)
                return <Row justify="center">
                    <Col>
                        <Typography.P>
                            {subscription_orderlist_task_first?.create_user_name}

                        </Typography.P>
                    </Col>
                </Row>
            }
        },
        {
            title: t("creation_time"),
            key: "create_time",
            sorter: false,
            dataIndex: "subscription_orderlist_task_data",
            sorter: false,
            render: (text, record, index) => {
                let subscription_orderlist_task_data = text || []
                let subscription_orderlist_task_first = subscription_orderlist_task_data?.find((ele) => true)
                return <Row justify="center">
                    <Col>
                        <Typography.P>
                            {subscription_orderlist_task_first?.create_time && dayjs(subscription_orderlist_task_first?.create_time).format("YYYY-MM-DD HH:mm:ss")}
                        </Typography.P>
                    </Col>
                </Row>
            }
        },
        {
            title: t("order_time_period"),
            key: "start_time",
            dataIndex: "subscription_orderlist_task_data",
            sorter: false,
            render: (text, record, index) => {
                let subscription_orderlist_task_data = text || []
                let subscription_orderlist_task_first = subscription_orderlist_task_data?.find((ele) => true)
                return <Row justify="center">
                    <Col>
                        <Typography.P>
                            {subscription_orderlist_task_first?.start_time ? dayjs(subscription_orderlist_task_first?.start_time).format("YYYY-MM-DD") : " - "}
                            ~
                            {subscription_orderlist_task_first?.end_time ? dayjs(subscription_orderlist_task_first?.end_time).format("YYYY-MM-DD") : " - "}
                        </Typography.P>
                    </Col>
                </Row>
            }
        },
        {
            title: t("journal_item_quantity"),
            key: "subscriptionid_count",
            dataIndex: "subscriptionid_count",
            sorter: false,
        },

        // {
        //     title: t("receivable_within_one_month"),
        //     key: "subscription_orderlist_items_data",
        //     dataIndex: "subscription_orderlist_items_data",
        //     sorter: false,
        //     render: (text, record, index) => {
        //         let subscription_orderlist_items_data = text || []
        //         let subscription_orderlist_items_first = subscription_orderlist_items_data?.find((ele) => true)
        //         return <Row justify="center">
        //             {subscription_orderlist_items_data.map((value) => {
        //                 let bibTitle = value?.title
        //                 let maxLength = 15
        //                 if (bibTitle?.length > maxLength) {
        //                     bibTitle = bibTitle.substring(0, maxLength)
        //                     return (
        //                         <Col span={24}>
        //                             <Button
        //                                 style={{
        //                                     whiteSpace: ""
        //                                 }}
        //                                 type="link" onClick={() => {
        //                                     navigate(`../serial_receive?subscriptionid=${value?.subscriptionid}`)
        //                                 }}>
        //                                 {bibTitle}...
        //                             </Button>
        //                         </Col>
        //                     )
        //                 }
        //                 else {
        //                     return (
        //                         <Col span={24}>
        //                             <Button
        //                                 style={{
        //                                     whiteSpace: ""
        //                                 }}
        //                                 type="link"
        //                                  onClick={() => {
        //                                     navigate(`../serial_receive?subscriptionid=${value?.subscriptionid}`)
        //                                 }}>
        //                                 {bibTitle}
        //                             </Button>
        //                         </Col>
        //                     )
        //                 }

        //             })}

        //         </Row>
        //     }
        // },


    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const [excelLoading, setExcelLoading] = useState(false);
    const [excelLoading2, setExcelLoading2] = useState(false);

    const navigate = useNavigate()


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const getExcel = () => {
        setExcelLoading(true)
        axios.get('/cataloging/budget_control_export', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 1000,
                // checkout_start_time: checkout[0].format("YYYY-MM-DD"),
                // checkout_end_time: checkout[1].format("YYYY-MM-DD"),
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `年度訂購經費統計分析與薦購數量統計 .xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setExcelLoading(false)
            })
    };
    const getReceive_excel = () => {
        setExcelLoading2(true)

        axios.get('/koha/serial/receive_export', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 100,
                // checkout_start_time: checkout[0].format("YYYY-MM-DD"),
                // checkout_end_time: checkout[1].format("YYYY-MM-DD"),
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `過期期刊及訂購清單列表.xlsx`);
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setExcelLoading2(false)
            })
    };

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const SerialController = useCRUDController({
        apiRoute: "/koha/serial",
    })
    const SerialOrderlistController = useCRUDController({
        apiRoute: "/library/subscription_orderlist",
        onFinish,
        onBefore
    })

    useEffect(() => {
        checkAll();
        SerialController.getData({
        })
    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <BudgetAndQuantityControl />
        </Col>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [
                        <Col span={24}>
                            <Row gutter={[4, 4]} align={"middle"}>
                                {/* <Col>
                                    <Typography.P>
                                        {t('order_time_period')}:
                                    </Typography.P>
                                </Col>
                                <Col>
                                    <DatePicker.Time
                                        placeholder={t(`time_start`)}
                                        format={"YYYY-MM-DD"}
                                        value={tableSearchParams?.start_planneddate ? tableSearchParams?.start_planneddate : undefined}
                                        onChange={(e) => {
                                            setTableSearchParams((pre) => {
                                                if (dayjs(e.target.value).isBefore(dayjs(pre?.end_planneddate, "YYYY-MM-DD"))) {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: pre?.end_planneddate,
                                                        end_planneddate: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Typography.Title level={4}>
                                        ~
                                    </Typography.Title>
                                </Col>
                                <Col>
                                    <DatePicker.Time
                                        placeholder={t(`time_end`)}
                                        format={"YYYY-MM-DD"}
                                        value={tableSearchParams?.end_planneddate ? tableSearchParams?.end_planneddate : undefined}
                                        onChange={(e) => {
                                            setTableSearchParams((pre) => {
                                                if ((dayjs(e.target.value)).isBefore(pre?.start_planneddate)) {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: e.target.value,
                                                        end_planneddate: pre?.start_planneddate,
                                                    }
                                                }
                                                else {
                                                    return {
                                                        ...pre,
                                                        end_planneddate: e.target.value,
                                                    }
                                                }

                                            })
                                        }}
                                    />
                                </Col>
                                {(tableSearchParams.start_planneddate || tableSearchParams.end_planneddate) &&
                                    <Col>
                                        <Button
                                            type={"icon"}
                                            onClick={() => {
                                                setTableSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        start_planneddate: undefined,
                                                        end_planneddate: undefined
                                                    }
                                                })
                                            }}>
                                            X
                                        </Button>
                                    </Col>
                                } */}
                                <Col>
                                    {permission_level === 1 ? 
                                    <Button
                                        loading={excelLoading}
                                        type='text'
                                        style={{
                                            color: "#fff",
                                            backgroundColor: "#56b673"
                                        }}
                                        onClick={() => {
                                            getExcel()
                                        }}
                                    >
                                        匯出年度訂購經費統計分析與薦購數量統計
                                    </Button>
                                    : <></>}
                                </Col>
                                <Col>
                                    {permission_level === 1 ? 
                                    <Button
                                        loading={excelLoading2}
                                        type='text'
                                        style={{
                                            color: "#fff",
                                            backgroundColor: "#56b673"
                                        }}
                                        onClick={() => {
                                            getReceive_excel()
                                        }}
                                    >
                                        匯出過期期刊及訂購清單列表
                                    </Button>
                                    : <></>}
                                </Col>
                                <Col>
                                    {permission_level === 1 ? 
                                    <PostButton
                                        ischildren={false}
                                        onClick={() => {
                                            navigate(`../serial_orderlist_management?mode=new`)
                                        }}
                                    />
                                    : <></>}
                                </Col>
                            </Row>
                        </Col>
                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        // subscriptionid: tableSearchParams?.subscriptionid,
                        ...newTableSearchParams,

                        // status: "1"
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return SerialOrderlistController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                }

                            })
                            SerialOrderlistController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                return {
                                    ...formValue,
                                    claimdate: !!formValue?.claimdate ? formValue?.claimdate : null
                                }
                            })
                            SerialOrderlistController.patchData(patchData)
                        },
                        deleteData: SerialOrderlistController.deleteData
                    }
                }}
                PropsPatchForm={<SerialOrderlistForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={false}
                propsWidth={2400}
                // scroll={{
                //     x: "100%",
                // }}
                extraActionRender={(record) => {
                    return (
                        permission_level === 1 ? <Row gutter={[8, 8]}>
                        <Col>
                            <PatchButton
                                onClick={() => {
                                    navigate(`../serial_orderlist_management?mode=edit&subscription_orderlist_id=${record?.subscription_orderlist_id}`)
                                }}
                            >
                            </PatchButton>
                        </Col>
                        <Col>
                            <Button
                                onClick={() => {
                                    navigate(`../serial_orderlist_management?mode=receive&subscription_orderlist_id=${record?.subscription_orderlist_id}`)
                                }}
                            >
                                查看訂單
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                onClick={() => {
                                    navigate(`../serial_orderlist_management?mode=new&subscription_orderlist_id=${record?.subscription_orderlist_id}`)
                                }}
                            >
                                {t('renew_subscription')}
                            </Button>
                        </Col>
                    </Row>: <></>)
                }}
            />
        </Col>
    </Row>)

}
const SerialOrderlist = ({
    keyPrefix = "cataloging.serial_orderlist_management",
    permission_level = null, 
}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    const subscription_orderlist_id = searchParams.get('subscription_orderlist_id');
    const mode = searchParams.get('mode');

    return (
        <Row gutter={[10, 20]} >
            {
                (mode === "view" || !mode) && <Col span={24}>
                    <SerialOrderlistTable
                        keyPrefix={keyPrefix}
                        propsSubscriptionid={subscription_orderlist_id}
                        permission_level={permission_level}
                    />
                </Col>
            }
            {
                (mode === "new" || mode === "edit" || mode === "receive") && <Col span={24}>
                    <SerialOrderlistEdit
                        keyPrefix={keyPrefix}
                        formView={mode === "receive" ? "onlyRead" : "edit"}
                    />
                </Col>
            }
        </Row>
    );
};
export { SerialOrderlistTable }
export default SerialOrderlist;
